// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__2KcfI","actions":"GroupTable_actions__25Ld7","deleteModalFooter":"GroupTable_deleteModalFooter__3PPiW"};